import { useAnytimeDocument } from "@/api/services/main/any-time";
import { DOCUMENT_STATUS, DOCUMENT_STEP_KEYS } from "@/types/enum";
import { useMemo } from "react";

type useCheckAnytimeDocumentReturn = {
  completed: boolean;
  finished: boolean;
  failed: boolean;
};

export const useCheckAnytimeDocument = (): useCheckAnytimeDocumentReturn => {
  const { data: documentResult } = useAnytimeDocument();
  const documentData = documentResult?.data;

  const completed = useMemo(() => {
    return documentData ? documentData.status === DOCUMENT_STATUS.COMPLETE : false;
  }, [documentData]);

  const finished = useMemo(() => {
    if (!documentData) return false;
    const checkKeys = [DOCUMENT_STEP_KEYS.ANY_TIME_CREATE_DOCUMENT, DOCUMENT_STEP_KEYS.ANY_TIME_UPLOAD_DOCUMENT];
    return documentData.steps.every(({ masterDocumentStep, status }) => {
      if (!checkKeys.includes(masterDocumentStep.stepKey)) return true;
      return status === DOCUMENT_STATUS.COMPLETE || status === DOCUMENT_STATUS.CONVERT_COMPLETE;
    });
  }, [documentData]);

  const failed = useMemo(() => {
    const checkKeys = [DOCUMENT_STEP_KEYS.ANY_TIME_CREATE_DOCUMENT];
    if (!documentData) return true;
    return documentData?.steps.some(({ masterDocumentStep, status }) => {
      if (checkKeys.includes(masterDocumentStep.stepKey)) {
        return status === DOCUMENT_STATUS.ERROR;
      }
      return false;
    });
  }, [documentData]);

  return {
    completed,
    finished,
    failed,
  };
};
